import React, { useEffect,useState } from 'react'
import '../Styles/Resturent.css'
import { useLocation, useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import { ResturentCategoryDetails, ResturentDetails } from '../Services/Operations/ProductAPI';

const Resturent = () => {
    const location = useLocation();
    const navigation = useNavigate();
    const [resturent, setResturent] = useState([]);
    const { longitude, latitude,categories_ids} = location.state || {};
    const BASE_URL = "https://zotpot.in";

    //console.log(longitude);
    //console.log("lattitude : ", latitude)
    const buttons = [
        { title: 'Filters 1', id: '0' },
        { title: 'Restuarent', id: '1' },
        { title: 'Cake Shop', id: '2' },
        { title: 'Sweet Shop', id: '3' },
        { title: 'Special Chat', id: '4' },
        { title: 'Bakery', id: '5' },
    ];

    const handleStoreClick = (store) => {
        navigation('/page-details', { state: { store } });
    };

    useEffect(() => {
        const fetchResturent = async () => {
            const formData = new FormData();
            formData.append("longitude", longitude);
            formData.append("latitude", latitude);
            const singleValue = categories_ids[0].value;
            //console.log("Single Value:", singleValue);
            
            formData.append("category_ids[0]",singleValue);

            for (let pair of formData.entries()) {
                //console.log(`${pair[0]}: ${pair[1]}`);
            }

            try {
                const response = await ResturentCategoryDetails(formData);
                setResturent(response)
                //console.log("resturent details : ", response);
            }
            catch (error) {
                console.error("Error fetching restaurant details:", error);
            }
        }
        fetchResturent();
    }, []);

    const fetchResturent1 = async (id) => {
        const formData = new FormData();
        formData.append("longitude", longitude);
        formData.append("latitude", latitude); 
        formData.append("category_ids[0]",id);

        for (let pair of formData.entries()) {
            //console.log(`${pair[0]}: ${pair[1]}`);
        }

        try {
            const response = await ResturentCategoryDetails(formData);
            setResturent(response)
            //console.log("resturent details : ", response);
        }
        catch (error) {
            console.error("Error fetching restaurant details:", error);
        }
    }

    return (
        <div>
            <header className="header">
                <div className="logo">
                    <Link to="/"><img style={{ width: "72px" }} src={require('../../Assets/zotpot.png')} /></Link>
                </div>
                <div className="location">
                    <span>Arambagh</span>
                </div>
            </header>
            <div className="button-container">
                <div className="scrollable" style={{ overflowX: "auto", scrollbarWidth: "none", }}>
                    {buttons.map((button) => (
                        <button
                            key={button.id}
                            className="button"
                            onClick={(()=>{fetchResturent1(button.id)})}
                        >
                            {button.title}
                        </button>
                    ))}
                </div>
            </div>
            <div className="stores-grid">
                {/* {stores.map((store) => (
                    <div className="store-item" key={store.id} onClick={() => handleStoreClick(store)}>
                        <img src={store.imgSrc} alt={store.name} />
                        <div style={{ marginLeft: "20px", display: "flex", flexDirection: "column", justifyContent: "normal", alignItems: "flex-start", }}>
                            <h3>{store.title}</h3>
                            <p>{store.name}</p>
                            <div className="store-details">
                                <span>{store.rating}</span>
                                <span>{store.time}</span>
                                <span>{store.price}</span>
                            </div>
                        </div>
                    </div>
                ))} */}
                {resturent.map((store) => (
                        <div style={{ height: "100px", textAlign: "left" }} className="store-item" key={store.id} onClick={() => handleStoreClick(store)}>
                            <img style={{ width: "105px" }} src={`${BASE_URL}${store.image}`} alt={store.name} />
                            <div style={{ marginLeft: "20px", display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "flex-start", }}>
                                <h3 style={{ margin: "0px" }}>{store.name}</h3>
                                <p style={{ margin: "0px" }}>{store.description}</p>
                                <div className="store-details">
                                    <span>{store.rating}</span>
                                    <span>{store.delivery_time} min</span>
                                    <span>{store.price_range}rs</span>
                                </div>
                            </div>
                        </div>
                    ))}
            </div>
        </div >
    )
}

export default Resturent
